import React from 'react';
import ReactDOM from 'react-dom';
import App from './root/App';
import { ApolloProvider } from "@apollo/react-hooks";
import Client from './Apollo/Client'
import { CookiesProvider } from 'react-cookie';

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={Client}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

